module.exports = __webpack_public_path__ + "static/media/mounatin2.bc7b2e73.jpg";